var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import cxs from 'cxs/component';
import Theme from 'Theme';
import { Icon } from 'elements';
import { Tooltip } from 'reactstrap';
var CheckBox = /** @class */ (function (_super) {
    __extends(CheckBox, _super);
    function CheckBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            tooltip: false
        };
        _this.handleToggleTooltip = function () {
            _this.setState(function (prev) { return ({ tooltip: !prev.tooltip }); });
        };
        _this.handleScroll = function () {
            _this.setState({ tooltip: false });
        };
        return _this;
    }
    CheckBox.prototype.componentDidMount = function () {
        window.addEventListener('scroll', this.handleScroll, false);
    };
    CheckBox.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.handleScroll);
    };
    CheckBox.prototype.render = function () {
        var _a = this.props, label = _a.label, checked = _a.checked, onChange = _a.onChange, id = _a.id, tooltipContent = _a.tooltipContent, props = __rest(_a, ["label", "checked", "onChange", "id", "tooltipContent"]);
        return (React.createElement(Label, __assign({ id: id }, props, { onClick: function () { return onChange(!checked); } }),
            React.createElement(Box, null, checked ? React.createElement(Icon, { style: {
                    padding: 0,
                }, name: "tick" }) : null),
            React.createElement(Span, { style: { textTransform: 'unset' } }, label),
            id && React.createElement(Tooltip, { target: id, isOpen: this.state.tooltip, toggle: this.handleToggleTooltip }, tooltipContent)));
    };
    return CheckBox;
}(Component));
export default CheckBox;
var Label = cxs('label')({
    display: 'block',
    padding: Theme.size.space[1]
});
var Box = cxs('div')({
    display: 'inline-block',
    width: Theme.fontSize.big,
    height: Theme.fontSize.big,
    marginRight: Theme.size.space[1],
    verticalAlign: 'sub',
    border: "".concat(Theme.size.hairline, " solid ").concat(Theme.color.hairline),
    '> icon': {
        padding: 0
    }
});
var Span = cxs('span')({
    display: 'inline-block'
});



//////////////////
// WEBPACK FOOTER
// ./src/elements/CheckBox.tsx
// module id = 946
// module chunks = 0